import React, {Component} from 'react'
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import doctorApi from "../../services/ApiServices/doctorApi";
import {authenticationService} from "../../services/AuthenticationService";


class Patient_Page_MedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            medical_diagnose_icd: this.props.medical_diagnose_icd,
            symptomsList: this.props.symptomsList
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    async componentDidMount() {
    }

    getICDDesc = (index) => {
        let {medical_diagnose_icd} = this.props
        medical_diagnose_icd = medical_diagnose_icd ? medical_diagnose_icd : []
        for (let j = 0; j < medical_diagnose_icd.length; j++) {
            if (index && medical_diagnose_icd[j].ICD_diagnosis_id.toString() === index.toString()) {
                return medical_diagnose_icd[j].Diagnosis_description
            }
        }
        return ""
    }

    getSymptomsDesc = (Symptom_ID, language) => {
        let {symptomsList} = this.props
        symptomsList = symptomsList ? symptomsList : []
        for (let j = 0; j < symptomsList.length; j++) {
            if (symptomsList[j].Symptom_ID.toString() === Symptom_ID) {
                if (language === "he") {
                    return symptomsList[j].Symptom_description_he
                } else {
                    return symptomsList[j].Symptom_description
                }
            }
        }
    }
    getConditionDesc = (conditionID, lang) => {
        let {medicalConditions} = this.props
        medicalConditions = medicalConditions ? medicalConditions : []
        let language = lang ? lang : localStorage.getItem('language')
        for (let j = 0; j < medicalConditions.length; j++) {
            if (medicalConditions[j].Condition_ID.toString() === conditionID.toString()) {
                if (language === "he") {
                    return medicalConditions[j].Condition_description_he
                } else {
                    return medicalConditions[j].Condition_description
                }
            }
        }
    }

    getAllergicDesc = (index) => {
        let {allergics} = this.props
        allergics = allergics ? allergics : []
        let language = localStorage.getItem('language')
        for (let j = 0; j < allergics.length; j++) {
            if (allergics[j].index === index) {
                return language === "he"?allergics[j].Allergic_name_he: allergics[j].Allergic_name
            }
        }
    }
    getMedicationDesc = (index) => {
        let {medications} = this.props
        medications = medications ? medications : []
        /*let language = localStorage.getItem('language')
        for (let j = 0; j < medications.length; j++) {
            if (medications[j].index === index) {
                return language === "he"?medications[j].Allergic_name_he: medications[j].Allergic_name
            }
        }*/
    }
    getInsuranceDesc = (index) => {
        let {medications} = this.props
        medications = medications ? medications : []
        /*let language = localStorage.getItem('language')
        for (let j = 0; j < medications.length; j++) {
            if (medications[j].index === index) {
                return language === "he"?medications[j].Allergic_name_he: medications[j].Allergic_name
            }
        }*/
    }
     getInsurace(insuranceID){
        let language = localStorage.getItem('language')
        switch (insuranceID) {
            case "1": return language==="he" ? "מכבי" : "Maccabi"
            case "2": return  language==="he" ? "כללית":"Clalit"
            case "3": return  language==="he" ? "לאומית":"Leumit"
            case "4": return  language==="he" ? "מאוחדת":"Meuhedet"
            case "5": return  language==="he" ? "חברת ביטוח":"Insurance company"
            case "6": return  language==="he" ? "צה\"ל":"IDF"
            case "7": return  language==="he" ? "משרד הביטחון":"Ministry of Defence"
            case "8": return  language==="he" ? "ללא ביטוח":"No Insurance"
            case "9": return  language==="he" ? "רשות פלסטינאית":"The Palestinian Authority"
            case "10": return language==="he" ? "אחר":"Other"
            default:return ""
        }
    }
    render() {

        let {t, isExpanded, patientLastRequest, patientInfo, showDemo} = this.props
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')

        let habits_medical = patientLastRequest && patientLastRequest.Habits_Medicals ? patientLastRequest.Habits_Medicals[0] : {}

        let patientIndication = patientLastRequest && patientLastRequest.Patient_type_indications ? patientLastRequest.Patient_type_indications[0] : {}
        let icd_med = this.getICDDesc(habits_medical.medical_diagnoses_icd_name)
        let referral_reason = patientIndication.ShowingReason

        let symptoms = patientLastRequest && patientLastRequest.Patient_symptoms ? patientLastRequest.Patient_symptoms : []
        let symptomsText = ""
        symptoms.map((item, index) => {
                let symptomDesc = this.getSymptomsDesc(item.Symptom_ID, language)
                symptomsText = index === 0 ? symptomsText + symptomDesc : symptomsText + ", " + symptomDesc
            })
        let insurance = patientInfo.PII?.Insuring_factor ? this.getInsurace(patientInfo.PII.Insuring_factor) : ""

        let smokedCannabisText = ""
        smokedCannabisText = habits_medical.Smoked_cannabis === "No" ?t('patient_boarding.no'): smokedCannabisText
        smokedCannabisText = habits_medical.Smoked_cannabis === "YesPast" ? t('patient_boarding.YesPast') :smokedCannabisText
        smokedCannabisText = habits_medical.Smoked_cannabis === "YesPresent" ?t('patient_boarding.YesPresent'): smokedCannabisText

        let Smoked_cannabis_cause = ""
        Smoked_cannabis_cause = habits_medical.Smoked_cannabis_cause === "Recreational" ?language==="he"? " | פנאי" :" | Recreational": Smoked_cannabis_cause
        Smoked_cannabis_cause = habits_medical.Smoked_cannabis_cause === "Medical" ?language==="he"? " | רפואי" : " | Medical":Smoked_cannabis_cause

        let Smoker = ""



        Smoker = habits_medical.Smoker === "Yes" ?t('patient_boarding.yes'): Smoker
        Smoker = habits_medical.Smoker === "No" ? t('patient_boarding.no_never'): Smoker
        Smoker = habits_medical.Smoker === "SmokePast" ? t('patient_boarding.no_past'):  Smoker


        let useOfAlcohol = habits_medical.Alcohol_usage ? habits_medical.Alcohol_usage : ""
        useOfAlcohol = useOfAlcohol === "Never" ? t('patient_boarding.AlcoholUsageNone') : useOfAlcohol
        useOfAlcohol = useOfAlcohol === "-1M" ? t('patient_boarding.-1M') : useOfAlcohol
        useOfAlcohol = useOfAlcohol === "2_4M" ? t('patient_boarding.2_4M') : useOfAlcohol
        useOfAlcohol = useOfAlcohol === "2_3W" ? t('patient_boarding.2_3W') : useOfAlcohol
        useOfAlcohol = useOfAlcohol === "4W" ? t('patient_boarding.4W') : useOfAlcohol
        let Patient_conditions = patientLastRequest && patientLastRequest.Patient_conditions ? patientLastRequest.Patient_conditions : []

        let medicalCond = ""
        if (Patient_conditions && Patient_conditions.length > 0) {
            Patient_conditions.map((item, index) => {
                medicalCond = index !== Patient_conditions.length - 1 ?
                    medicalCond + this.getConditionDesc(item.Condition_ID) + ", " :
                    medicalCond + this.getConditionDesc(item.Condition_ID)
            })
        }


        let pAllergics = habits_medical['patient_allergics'] ? habits_medical.patient_allergics : ""
        pAllergics = pAllergics ? pAllergics.split(',') : ""

        let patient_allergics = ""
        for (let i = 0; i < pAllergics.length; i++) {
            let index = parseInt(pAllergics[i])
            patient_allergics = i !== pAllergics.length - 1 ?
                patient_allergics +  this.getAllergicDesc(index) + ", " :
                patient_allergics +  this.getAllergicDesc(index)
        }

        let Patient_Medications = patientLastRequest && patientLastRequest.Patient_Medications ? patientLastRequest.Patient_Medications : []
        let meds = ""
        for (let i = 0; i < Patient_Medications.length; i++) {

            if(Patient_Medications[i].General_Thinner_Past ==="Past"){
                let index = parseInt(Patient_Medications[i].Med_ID)
                // this.getMedicationDesc()
                meds = meds!=="" ?
                    meds +  ", " +Patient_Medications[i].Medication_name:Patient_Medications[i].Medication_name

            }


        }

        return (

            <div className={'formBoxes_patientPage'}>

                <div className={'patientsFormRow'}>
                    <div className={'patientsPageRowBox'}>
                        <div className={'title-infoLabel-patientPage'}>{t('patientPage.icd_diagnosis')}</div>

                        {!showDemo &&
                        <div className={'value-infoLabel-patientPage'}>{icd_med}</div>
                        }
                        {showDemo &&
                        <div className={'value-infoLabel-patientPage'}>Chronic pain syndrome</div>
                        }
                    </div>

                    <div className={'patientsPageRowBox'}>
                        <div className={'title-infoLabel-patientPage'}>{t('patientPage.ReferralReason')}</div>

                        {!showDemo &&
                        <div className={'value-infoLabel-patientPage'}>{referral_reason}</div>
                        }
                        {showDemo &&
                        <div className={'value-infoLabel-patientPage'}>כאבים בגב התחתון עם הקרנה לרגל ימין</div>
                        }

                    </div>

                    <div className={'patientsPageRowBox'}>
                        <div className={'title-infoLabel-patientPage'}>{t('patientPage.Target_Symptoms')}</div>
                        {!showDemo &&
                        <div className={'value-infoLabel-patientPage'}>{symptomsText}</div>
                        }
                        {showDemo &&
                        <div className={'value-infoLabel-patientPage'}>כאב כרוני, הפרעות שינה</div>
                        }

                    </div>

                    <div className={'patientsPageRowBox'}>
                        <div className={'title-infoLabel-patientPage'}>{t('patientPage.Insurance')}</div>
                        {!showDemo &&
                        <div className={'value-infoLabel-patientPage'}>{insurance}</div>
                        }

                        {showDemo && <div className={'value-infoLabel-patientPage'}>חברת ביטוח</div>
                        }

                    </div>
                </div>
                {isExpanded &&
                <div>
                    <div className={'patientPage_spaceLine'}/>

                    <div className={'patientsFormRow'}>
                        <div className={'patientsPageRowDoubleBox'}>

                            <div
                                className={'title-infoLabel-patientPage'}>{t('patientPage.Previous_use_cannabis')}</div>

                            {!showDemo && <div
                                className={'value-infoLabel-patientPage'}>{smokedCannabisText + Smoked_cannabis_cause}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>כן בעבר | פנאי</div>}


                        </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.smoking')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{Smoker}</div>}

                            {showDemo && <div className={'value-infoLabel-patientPage'}>לא, בעבר עישנתי</div>}


                        </div>

                        <div className={'patientsPageRowBox'}>

                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.use_of_alcohol')}</div>


                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{useOfAlcohol}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>אף פעם</div>}

                        </div>
                    </div>

                    <div className={'patientsFormRow'} style={{margin: '35px 0px'}}>
                        <div className={'patientsPageRowDoubleBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.Medical_History')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{medicalCond}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>לחץ דם גבוה</div>}

                        </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.Allergies')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{patient_allergics}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>ללא</div>}

                        </div>

                        <div className={'patientsPageRowBox'}>
                            <div className={'title-infoLabel-patientPage'}>{t('patientPage.current_medications')}</div>

                            {!showDemo && <div className={'value-infoLabel-patientPage'}>{meds}</div>}
                            {showDemo && <div className={'value-infoLabel-patientPage'}>Percocet , Butrans 15 mg</div>}

                        </div>
                    </div>
                </div>
                }
            </div>

        )
    }
}

Patient_Page_MedicalInfo.propTypes = {

    isDisabled: PropTypes.bool
}

export default Patient_Page_MedicalInfo;
